import * as React from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

export default function LinerProgressBar(props: any) {
    const renderSwitch = (param: any) => {
        switch(param) {
            case 'processing':
                return '';
            case 'uploading':
                return <LinearProgress />;
            case 'faceNetProcessing':
                return <LinearProgress />;
            case 'detectedCamera':
                return <LinearProgress />;
            default:
                return '';
        }
    }
    return (
        <Box sx={{ width: '100%' }}>
            {renderSwitch(props.value)}
        </Box>
    );
}
